import { Button, Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import React from 'react'
import { HiDotsHorizontal } from 'react-icons/hi'
import { Link } from 'react-router-dom'
import TabUser from './TabUser'

const UserList = ({ userList, activeTab, setActiveTab, loading, error, onRefresh }) => {
  return (
    <div className='mx-4 pb-6 md:mx-6'>
      <div className='mb-5 mt-3 flex items-center justify-between gap-3'>
        <div className='rounded-[20px] border border-slate-200 bg-white px-4 py-3 shadow-[0_10px_26px_rgba(15,23,42,0.05)]'>
          <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Visible users</p>
          <p className='mt-1 text-sm font-[GilroyBold] text-slate-900'>{userList?.length || 0}</p>
        </div>
        <Button onClick={onRefresh} className='rounded-full bg-[#f97316] px-6 py-3 text-xs font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(249,115,22,0.22)] hover:bg-[#ea580c]'>
          Refresh List
        </Button>
      </div>

      <TabUser activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className='overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
        <div className='overflow-x-auto'>
          <table className='min-w-full border-separate border-spacing-0'>
            <thead>
              <tr className='bg-[#fffaf6]'>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Name</th>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Contact No</th>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>GST No</th>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Company Name</th>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Insurance Type</th>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Role</th>
                <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Email</th>
                <th className='border-b border-slate-200 px-5 py-4 text-center text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} className='px-5 py-16 text-center'>
                    <p className='text-base font-[GilroyMedium] text-slate-500'>Loading users...</p>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan={8} className='px-5 py-16 text-center'>
                    <p className='text-base font-[GilroyMedium] text-red-500'>{error}</p>
                  </td>
                </tr>
              ) : userList?.length ? userList.map((user) => (
                <tr key={user?.id} className='transition-colors hover:bg-slate-50/70'>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyBold] text-slate-900'>{user?.name || '-'}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{user?.contact || '-'}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{user?.gstNo?.length ? user?.gstNo : "-"}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{user?.companyName?.length ? user?.companyName : "-"}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{user?.insuranceType?.length ? user?.insuranceType : "-"}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{user?.role?.length ? user?.role : "-"}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{user?.email || '-'}</td>
                  <td className='border-b border-slate-100 px-5 py-4 text-center'>
                    <Menu className="rounded-xl px-0 py-1">
                      <MenuHandler>
                        <Button variant='text' className="rounded-full p-1.5 text-slate-600 shadow-none hover:bg-slate-100 hover:shadow-none">
                          <HiDotsHorizontal className="text-[1.1rem]" />
                        </Button>
                      </MenuHandler>
                      <MenuList className="w-[160px] px-0 rounded-xl">
                        <Link className="outline-none border-none" to={`/users/${user?.id}`}>
                          <MenuItem className="border-b border-gray-200 rounded-none px-0">
                            <p className="px-5 text-black font-[GilroyRegular]">Edit User</p>
                          </MenuItem>
                        </Link>
                        <Link className="outline-none border-none" to={`/user/${user?.id}`}>
                          <MenuItem className="border-b border-gray-200 rounded-none px-0">
                            <p className="px-5 text-black font-[GilroyRegular]">View User</p>
                          </MenuItem>
                        </Link>
                        <MenuItem className="rounded-none px-0">
                          <p className="px-5 text-red-600 font-[GilroyRegular]">Delete User</p>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={8} className='px-5 py-16 text-center'>
                    <p className='text-base font-[GilroyMedium] text-slate-500'>No users found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default UserList
